module.exports = __webpack_public_path__ + "img/9791187206545.2e91403d.jpg";